import { useMediaQuery } from 'react-responsive';

export  const useDesktop = () => {
  const desktop = useMediaQuery({
    query: '(min-width: 1200px)'
  });

  return desktop;
}

export  const useTabletls = () => {
  const tabletls = useMediaQuery({
    query: '(min-width: 992px)'
  });

  return tabletls;
}

export const useTablet = () => {
  const tablet = useMediaQuery({
    query: '(min-width: 768px)'
  });

  return tablet;
}

export const useMobile = () => {
  const mobile = useMediaQuery({
    query: '(min-width: 576px)'
  });

  return mobile;
}